export default __webpack_public_path__ + "static/media/jessicapeony_six.53dcffa8.jpg";